import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Slider2.css"


export default function Slider() {
    const swiperWrappedRef = useRef(null);

    function adjustMargin() {
        const screenWidth = window.innerWidth;

        if (swiperWrappedRef.current) {
            swiperWrappedRef.current.style.marginLeft =
            screenWidth <= 520
            ? "0px"
            : screenWidth <= 650
            ? "-50px"
            : screenWidth <= 800
            ? "-100px"
            : "-150px";
        }
    }

    useEffect(() => {
        adjustMargin();
        window.addEventListener("resize", adjustMargin);
        return () => window.removeEventListener("resize", adjustMargin);
    }, []);
    return (
        <>
        <div id='services' className='title_slider2'>
            <div className='content_slider'>
                <h2>Våra Bilar</h2>
            </div>
            <div className="container_slider">
                <Swiper 
                    modules={[Pagination]}
                    z-index={-1}
                    grabCursor
                    initialSlide={2}
                    centeredSlides
                    slidesPerView="auto"
                    speed={800}
                    slideToClickedSlide
                    pagination={{clickable: true}}
                    breakpoints={{
                        320: { spaceBetween: 40 },
                        650: { spaceBetween: 30 },
                        1000: { spaceBetween: 20 }
                    }}
                    onSwiper={(Swiper) => {
                        swiperWrappedRef.current = Swiper.wrapperEl
                    }}
                >
                        <SwiperSlide>
                            <div className="img_car_slider" />
                            <div className="content">
                            </div>
                        </SwiperSlide>        
                       <SwiperSlide>
                            <div className="img2_car_slider"></div>
                            <div className="content">
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img3_car_slider"></div>
                            <div className="content">
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img4_car_slider"></div>
                            <div className="content">
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img5_car_slider"></div>
                            <div className="content">
                            </div>
                        </SwiperSlide>
                </Swiper>
            </div>
        </div>
        </>
    )
}